import { useTransferirEscopoMacroDialog } from "./use-transferir-escopo-macro-dialog";
import { TransferirEscopoMacroDialogView } from "./view-transferir-escopo-macro-dialog";
import type { TransferirEscopoMacroDialogProps } from "./types-transferir-escopo-macro-dialog";

export function TransferirEscopoMacroDialog(props: TransferirEscopoMacroDialogProps) {
  const vm = useTransferirEscopoMacroDialog(props);

  return <TransferirEscopoMacroDialogView {...vm} />;
}

export type * from "./types-transferir-escopo-macro-dialog";
